type Translator = (key: string, options?: Record<string, unknown>) => string;

export const CV_DELETE_TARGETS = [
  "position",
  "achievement",
  "education",
  "certification",
  "highlight",
  "project",
  "language",
  "skillGroup",
  "skill",
  "link",
  "jobTitle",
  "searchArea",
] as const;

export type CvDeleteTarget = (typeof CV_DELETE_TARGETS)[number];

export function getCvDeleteConfirmationCopy(
  t: Translator,
  target: CvDeleteTarget,
) {
  const object = t(`cv.edit.deleteTargets.${target}`);

  return {
    title: t("cv.edit.deleteItemTitle", { object }),
    message: t("cv.edit.deleteItemMessage", { object }),
  };
}
